<section class="main_section">
  <div class="total-container">
    <div class="header-section">
      <div class="create-text" *ngIf=" !data.edit">Add New Category</div>
      <div class="create-text" *ngIf="data.edit">Update Category</div>
      <div class="close-btn" (click)="closebutton()" *ngIf="srcWidth > 475">
        <img src="../../../../../../assets/images/close.svg" alt="">
      </div>
    </div>
    <div class="body-section">

      <div class="attachment-section">
        <div class="input-label"> Category Image</div>

        <div class="profile-img ">
          <div class="attach-header">
            <ng-container *ngIf="nodeAttachements?.length == 0">
              <div class="fc_browse" *ngIf="nodeAttachements">
                <span class="attach-files-span" (click)="fileInput.click()">
                  <span class="plus">+</span>
                  Upload
                </span>
              </div>
            </ng-container>


          </div>
          <div class="image-box" *ngIf="nodeAttachements?.length > 0 && !pageLoader">
            <div class="image_box">
              <span class="fc_browse_btn" id="display_browse_btn" (click)="fileInput.click()">
                <span class="plus">+</span>
                Upload
              </span>
            </div>
          </div>

          <input id="vendorImage" type="file" name="myfile"
            accept="image/jpg,image/jpeg,image/gif,image/png,image/x-eps"
            (change)="updateContactImage($event)" class="pc-btn" id="browse_contact_image" #fileInput />
          <div class="addedImg">
            <ng-container *ngFor="let items of nodeAttachements; let i = index">
              <div *ngIf="items.attachmentType=='IMAGE'" class="image-container">
                <div class="uploadedImg">
                  <div class="image_name">
                    <img [src]="ds.bypassSecurityTrustUrl(items.url)" alt="" class="given-img">
                    <div class="button-delete-change" (click)="delete(i)">
                      <div class="delete_button">
                        <img src="assets/images/master/delete-icon.svg" alt="delete">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="items.attachmentType=='FILE'">
                <div class="pdf-files-changes">
                  <div class="person-details box-line">
                    <div class="icon">
                      <img src="../../../../../assets/images/invoice/pdf-icon.svg" alt="">
                    </div>
                  </div>
                  <div class="image-buttons">
                    <div class="button delete-change" (click)="delete(i)">
                      <div class="delete">
                        <img src="../../../../../assets/images/invoice/delete_invoice.svg" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- </ng-container> -->
        </div>
      </div>
      <div class="product-image">
        Product images must be PNG or JPEG, recommended 1024 px by 1024 px or 1:1 aspect ratio.
      </div>

      <div class="lead-section content-box">
        <div class="invoice-info">
          <div class="input-box1">
            <div class="input-label">Category Name<sup>*</sup></div>
            <mat-form-field class="full-width input_card" appearance="outline">
              <input matInput placeholder="Enter category Name" value="" [(ngModel)]="categoryData.categoryName">
            </mat-form-field>
          </div>
        </div>

      </div>
      <div class="lead-section-description">
        <div class="invoice-info">
          <div class="content-box full">
            <div class="input-label">Description<sup>*</sup></div>
            <mat-form-field class="full-width-text input_card" appearance="outline">
  <textarea
    matInput
    [(ngModel)]="categoryData.description"
    placeholder="Enter category description"
    rows="3"
    maxlength="200"
    class="text-area"
    cdkTextareaAutosize
    cdkAutosizeMinRows="3"
    cdkAutosizeMaxRows="8">
  </textarea>
  <mat-hint align="end">{{ categoryData.description?.length || 0 }}/200</mat-hint>
</mat-form-field>

          </div>
        </div>
      </div>

      <div class="content-box full" style="margin-top: 0px;">
        <div class="input-label">
          Sub Industry
        </div>
    
        <mat-form-field class="full-width input_card" appearance="outline">
          <mat-select class="full-width2" [(ngModel)]="categoryData.subIndustryId" (ngModelChange)="getCategoryCollectionBySubIndustryId($event)">
            <mat-option *ngFor="let option of ecomIndustry" [value]="option.subIndustryId">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="lead-section-description">
        <div class="invoice-info">
          <div class="content-box full">
            <div class="input-label">Collection<sup>*</sup></div>
            <mat-form-field class="sfull-width" appearance="outline" style="width: 100%;">
              <mat-select multiple placeholder="--Select Collection--" [(ngModel)]="selectedCollectionId"
                #collectionSelectElement>
                <div class="selectalls-check">
                  <mat-checkbox (click)="onSelectAllCollection(allCollectionCheckbox)" #allCollectionCheckbox>
                    select all</mat-checkbox>
                </div>

                <ng-container *ngFor="let collection of collectionList">
                  <mat-option [value]="collection.collectionId"
                    (click)="selectCollection(collectionOption, collection, allCollectionCheckbox)" #collectionOption>
                    {{ collection.collectionName | titlecase }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="browse-prod">
        <div class="search-bar">
          <mat-form-field class="sfull-width" appearance="outline" style="width: 100%;">
            <div class="data-search">
              <mat-icon matPrefix class="mat-search-icon">search</mat-icon>
            </div>
            <input matInput placeholder="Search by name" style="height: 34px!important;" />
          </mat-form-field>
        </div>
         <div (click)="openDialog()" class="browse">
          Browse <span><mat-icon class="right-arrow">keyboard_arrow_right</mat-icon></span>
         </div>
      </div>

    </div>
    <div class="footer-section">
      <div class="cancle-section">
        <button class="cancle" (click)="closebutton()">Cancel</button>
      </div>
      <div class="createCont-section">
        <button class="create-contact" (click)="createCategories()" *ngIf="!data.edit">
          <span *ngIf="submitLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
          <span *ngIf="!submitLoader">+ Add Category</span>
        </button>

        <button class="create-contact" (click)="createCategories()" *ngIf="data.edit">
          <span *ngIf="submitLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
          <span *ngIf="!submitLoader">Update Category</span>
        </button>
      </div>

    </div>

  </div>


</section>
